import React, { useState, useEffect, useContext } from "react";
import { SessionContext } from '../context/sessionContext';

import DatePicker from "react-datepicker";

import { Form, Row, Col } from "react-bootstrap";

import SelectInput from "./selectInput";

import {optionsTramitacionADA, optionsTramitacionResolucion, optionsTramitacionVisado, optionsTramitacionCPU} from "../datos/options";

/*
EX 20-09-2026 (fase 2 - paso 4b) - FORMULARIO UNICO de la pestaña "Tramite" (Tab 2).

Antes habia DOS copias de este formulario: tramiteExp.js (alta) y tramiteEditExp.js (edicion), con 81,2%
de similitud. Sus diferencias reales eran casi todas la MISMA cosa (la precarga de los datos guardados),
asi que ahora hay un solo componente y esas diferencias son props de CAPACIDAD: no hay ningun
`modo === 'alta' ? ...`. El default de todas las capacidades es el ALTA, asi que expediente.js no pasa
ninguna prop y grupo_editexpediente.js pasa las que necesita.

  precargarDatos                 - la edicion muestra los valores que ya trae `inputsTram`. Donde el campo
                                   es controlado se pasa `value`, donde es no controlado `defaultValue` y
                                   los checkboxes pasan `checked`. Con false no se pasa NINGUNO de los tres
                                   (valorInicial devuelve undefined). No es lo mismo que pasar un valor
                                   vacio: el value/defaultValue/checked se aplica al montar y el alta no se
                                   tiene que "acordar" de un expediente que se cargo antes.
  limpiarProyHidraulicoEnUrbana  - con true (alta) el check "Proyecto Hidraulico" no solo se deshabilita
                                   cuando Area = URBANA: ademas se limpia el valor en inputsTram. La
                                   edicion solo lo deshabilita, para no pisar el dato guardado del
                                   expediente, asi que pasa false.
  deshabilitarAnotacionesPorTipo - con true (edicion) el check "Anotaciones personales" queda deshabilitado
                                   cuando Tipo = INMUEBLES DEL ESTADO. El alta NO tenia ese efecto: declara
                                   isDisabledTipo y nunca escribe el estado, o sea que ahi ese check nunca
                                   se deshabilita (por eso el default es false y no cambia nada del alta).

Las diferencias que resolvio `precargarDatos` eran 7 controles + 25 checkboxes:
  - 7 controles que la edicion precargaba y el alta no pasaba nada: SelectInput Tramitacion ADA
    (t_127_tramitacion_ada_prefac_h), input Expediente ADA (expediente_prefac_h_t), textarea Observaciones
    tramitacion ADA (t_131_observaciones_prefact_h), SelectInput Tramitacion CPU (t_145_cpu_tramitacion),
    SelectInput Tramitacion visado (t_137_tramitacion_visado), SelectInput Tramitacion resolucion
    (t_132_tramitacion_resol) y textarea Observaciones tramitacion resolucion (t_136_observaciones_resol).
  - los 25 checkboxes del formulario: la edicion pasaba `checked={...}` y el alta no pasaba nada.
  - los 5 cuadros de observaciones (reporte al municipio, internas, t_131, t_136 y t_140). En t_131 y t_136
    estaba la diferencia real (la edicion precargaba y el alta no pasaba nada), asi que esos dos pasan por
    valorInicial. Los otros tres (reporte, internas y t_140) ya pasaban `value` en los DOS flujos, asi que
    quedan con `value={...}` DIRECTO, sin valorInicial: asi el alta queda byte-identica (controlada con valor
    vacio, que es lo que ya hacia) y la edicion tambien. Lo mismo vale para los otros tres campos que ya
    pasaban value en los dos flujos (input t_148_cpu_nro_gdeba, input numero_especial_resol_t y textarea
    t_149_cpu_observaciones): quedaron como estaban. O sea que valorInicial se usa SOLO donde habia una
    diferencia real que resolver.

El onChange que quedo es el de la EDICION, que ya era el superconjunto del del alta: la firma es (e, date)
y ademas de lo mismo escribia 5 estados val* (val, valInternas, valADA, valResolucion, valTramVisado). Esos
5 estados se borraron en el paso 7: se escribian y NINGUNA parte del JSX los leia (los textarea se manejan
solos), asi que eran estados de ida. Lo unico del onChange de la edicion que NO se copio es su
`else { //console.log("CAMBIO UN DATEPICKER"); }` final: es un else vacio (codigo inerte) que el alta no
tenia. El guard del auto-alto del paso 4a se conserva tal cual: `if (type === 'textarea' || type === 'text')`
envolviendo los dos `e.target.style.height = ...` (sin ese guard los <select> vuelven a achicarse).

Micro-unificacion visible de este paso (la unica): el label del textarea de observaciones internas. El alta
decia "Observaciones internas" y la edicion "Observaciones Internas" -> queda el del alta (minusculas), que
es el default de todo el formulario. Solo cambia una mayuscula, y solo se ve en la edicion.

Limpieza del paso 7 (HECHA): se borro el codigo muerto que la fusion dejo a la vista, verificando muerte real
en ESTE archivo (no en los originales: la fusion cambio quien usa que):
  - los 5 estados val* (ver arriba) y sus 5 bloques if dentro del onChange;
  - isDisabledAnotaciones: se declaraba y nadie la leia ni la escribia (el check usa isDisabledTipo);
  - el setter de isDisabledVisadoPlano: no se llamaba nunca, asi que el estado era SIEMPRE false -> quedo
    como constante `const isDisabledVisadoPlano = false;`, para que se vea que es fijo y no un estado que
    alguien deberia estar actualizando;
  - los 6 useRef textArea* (se pasaban a los textarea y nunca se leia .current), sus atributos ref= y el
    import de useRef, que quedo sin uso; y `original` del destructuring del contexto;
  - 14 console.log (13 comentados + el activo "change tipo") y los bloques de comentario que duplicaban
    los handlers de fecha (estaban entrelazados con los vivos, asi que se quitaron solo los comentados);
  - 19 comentarios de linea entera en el JSX (llave, barra-asterisco, texto, asterisco-barra), la mayoria
    codigo comentado. AVISO: unos pocos NO eran codigo sino ETIQUETAS estructurales del markup (las que
    dicen DOS, ABRE bloque PREFACTIBILIDAD HIDRAULICA, cierra NUEVA CPU). No cambian nada en runtime,
    pero eran ayudas de lectura: si se extrañan hay que reponerlas a mano.
  Queda sin tocar, a proposito: la rama vacia `} else if(type === 'number'){` (sacarla obliga a reescribir el
  encadenado del else, y es inerte) y el `const { type } = e.target;`, donde `name` y `value`
  siguen sin usarse.
Ojo con el wrapper: el alta devolvia el <div> pelado y la edicion lo envolvia en <Fragment> (que no agrega
nada al DOM: el arbol renderizado es el mismo). Queda el del alta, asi que el import de Fragment no hace
falta en este archivo.
*/

const TramiteExp = ({
	inputsTram, setInputsTram, inputs, setInputs,
	//EX 20-09-2026 (fase 2 - paso 4b): capacidades del flujo de EDICION. El default de todas es el ALTA, asi
	//que expediente.js no pasa ninguna y sigue igual (ver el encabezado de arriba).
	precargarDatos = false,
	limpiarProyHidraulicoEnUrbana = true,
	deshabilitarAnotacionesPorTipo = false
}) => {

	const { cambioOriginal } = useContext(SessionContext);

	//EX 20-09-2026 (fase 2 - paso 4b): helper unico de precarga, igual al de datosExp.js. Con
	//precargarDatos = false devuelve undefined, que es lo mismo que NO pasar la prop (value / defaultValue /
	//checked): el alta queda no controlado, como estaba.
	const valorInicial = (valor) => (precargarDatos ? valor : undefined);

	//Pestaña TRAMITES ---> 5 inputs fecha
	const {
		//EX 20-09-2026 (fase 2 - paso 4b): esta lista era un SUBCONJUNTO de la de la edicion: el alta
		//destructuraba solo lo que usaba y tenia comentados solicitud_adhesion_t y
		//t_127_tramitacion_ada_prefac_h. En el componente unico hacen falta los 25 names de los checkboxes
		//(los usa valorInicial para `checked`), asi que quedan activos, como en la edicion.
		solicitud_adhesion_t, certif_urbanistico_municipal_t, certif_no_inundabilidad_t, anteproyecto_urbano_t, titulo_propiedad_t,
		informe_dominio_t, admisibilidad_inicial_t, prefactibilidad_urbanistica_t, prefactibilidad_hidraulica_t,
		memoria_descriptiva_obras_t, energia_electrica_t, apertura_calles_t, plano_mensura_t, ordenanza_municipal_t, memoria_descriptiva_procedimientos_t,
		certif_tecnico_urbanistico_t, resolucion_afectacion_t, visado_plano_t,
		anotaciones_personales_t, //107
		agua_potable_t, //113
		eliminacion_excretas_t, //114 para usar en la propiedad checked del input checkbox
		acta_constitutiva_t, //116
		certif_vigencia_persona_juridica_t, //117
		convenio_urbanistico_t, //119
		t_127_tramitacion_ada_prefac_h, //127
		fecha_envio_prefac_h_t, expediente_prefac_h_t, fecha_emision_prefac_h_t,
		t_131_observaciones_prefact_h, //131
		t_132_tramitacion_resol, //132
		fecha_envio_resol_t, fecha_emision_resol_t,
		numero_especial_resol_t,
		t_136_observaciones_resol,
		t_137_tramitacion_visado,
		fecha_visado_plano_t,
		observaciones_internas_t,
		observaciones_reporte_t,
		t_139_fecha_entrega, //139 - ADD 20-09-2022
    	t_140_observaciones_tramitacion, //140 - ADD 20-09-2022
		t_144_proyecto_hidraulico, //144 -- add 22-12-2022
		t_145_cpu_tramitacion, //145 --add 14-JUN-2024
		t_146_cpu_fecha_envio, //146 --add 14-JUN-2024
		t_147_cpu_fecha_emision, //147 --add 14-JUN-2024
		t_148_cpu_nro_gdeba, //148 --add 14-JUN-2024
		t_149_cpu_observaciones //149 --add 14-JUN-2024
	} = inputsTram;

	//add 5-01-2023

	//***PARA cuadro de texto
	

	const {tipo, sistema_agua, eliminacion_excretas, titular_tierra, area} = inputs;

	//****10-06-2023 */
	//Deshabilitar el check de 'Proyecto Hidraulico'(Tramitac) solo si "Area" (Datos Generales)=Urbana
	const [isDisabledProy_Hidraul, setIsDisabledProy_Hidraul] = useState(false);
	//const [isActivo, setIsActivo] = useState(false);

	useEffect(()=>{
		if(area === "URBANA"){
			setIsDisabledProy_Hidraul(true);

			//EX 20-09-2026 (fase 2 - paso 4b): limpiarProyHidraulicoEnUrbana - el alta, ademas de
			//deshabilitar el check, limpia su valor en inputsTram cuando Area = URBANA. La edicion solo lo
			//deshabilita, para no pisar el dato guardado del expediente, asi que pasa false. Con el default
			//true el alta queda igual que antes.
			if (limpiarProyHidraulicoEnUrbana) {
				setInputsTram({ ...inputsTram, t_144_proyecto_hidraulico: eval(false) });
			}
		} else {
			setIsDisabledProy_Hidraul(false);
		}
	}, [area])
	//-------10-06-2023 --/

	//** contador Observac. tramitacion ADA
	const [maxObservTramADA, setMmaxObservTramADA] = useState(500);
	useEffect(()=>{
		const maxTADA = 500;
		if(t_131_observaciones_prefact_h){
			if(t_131_observaciones_prefact_h !== "" || t_131_observaciones_prefact_h !== null){
				var restantesR = maxTADA - t_131_observaciones_prefact_h.length;
				setMmaxObservTramADA(restantesR);
			}
		} else {
			setMmaxObservTramADA(maxTADA);
		}
	}, [t_131_observaciones_prefact_h]);
	//---cierra Observac. tramitacion ADA

	//** contador Observ. Resolucion
	const [maxObservResol, setMmaxObservResol] = useState(500);
	useEffect(()=>{
		const maxResol = 500;
		if(t_136_observaciones_resol){
			if(t_136_observaciones_resol !== "" || t_136_observaciones_resol !== null){
				var restantesR = maxResol - t_136_observaciones_resol.length;
				setMmaxObservResol(restantesR);
			}
		} else {
			setMmaxObservResol(maxResol);
		}
	}, [t_136_observaciones_resol]);

	//*** CONTADOR Observ Internas
	const [maxObservaciones, setMaxObservaciones] = useState(3000);
	useEffect(()=>{
		const maxOI = 3000;

		if(observaciones_internas_t){
			if(observaciones_internas_t !== "" || observaciones_internas_t !== null){
				var restantes = maxOI - observaciones_internas_t.length;
				setMaxObservaciones(restantes);
			}
		} else {
			setMaxObservaciones(maxOI);
		}
	}, [observaciones_internas_t]);
	//--cierra CONTADOR

	//**CONTADOR OBSERV Reportes
	const [maxObservR, setMaxObservR] = useState(3000);
	useEffect(()=>{
		const maxOR = 3000;
		if(observaciones_reporte_t){
			if(observaciones_reporte_t !== "" || observaciones_reporte_t !== null){
				var restantesR = maxOR - observaciones_reporte_t.length;
				setMaxObservR(restantesR);
			}
		} else {
			setMaxObservR(maxOR);
		}
	}, [observaciones_reporte_t]);
	//---CIERRA-----

	//**** contador Observaciones visado (140) maxObservaciones_140***
	const [maxObservaciones_140, setMaxObservaciones_140] = useState(2000);
	useEffect(()=>{
		const maxOV = 2000;
		if(t_140_observaciones_tramitacion){
			if(t_140_observaciones_tramitacion !== "" || t_140_observaciones_tramitacion !== null){
				var restantesRV = maxOV - t_140_observaciones_tramitacion.length;
				setMaxObservaciones_140(restantesRV);
			}
		} else {
			setMaxObservaciones_140(maxOV);
		}
	}, [t_140_observaciones_tramitacion]);
	//---cierra CONTADOR

	//**14-03-2022: NO HABILITAR si se cumplen las tres condiciones: Área = 1, Sistema de Agua= 1 y Eliminación de Excretas= 1
	//EX 21-09-2026 (paso 7): el setter de este estado no se llama nunca, asi que el valor
	//es siempre el inicial (false). Queda como constante para que se vea que es fijo.
	const isDisabledPrefacHidraulica = false;

	//**tipo. NO Habilitar si tipo = inmuebles del estado
	const [isDisabledTipo, setIsDisabledTipo] = useState(false);

	//EX 20-09-2026 (fase 2 - paso 4b): deshabilitarAnotacionesPorTipo - este efecto existia SOLO en la
	//edicion: cuando Tipo = INMUEBLES DEL ESTADO deshabilita el check "Anotaciones personales" (el check lee
	//isDisabledTipo). El alta declara ese estado y NUNCA lo escribe, o sea que ahi el check queda siempre
	//habilitado: con el default false este efecto retorna enseguida y el alta sigue igual. La condicion y el
	//console.log son los que ya tenia la edicion.
	useEffect(() => {
		if (!deshabilitarAnotacionesPorTipo) {
			return;
		}

		if (tipo === "INMUEBLES DEL ESTADO"){
			setIsDisabledTipo(true);
		} else {
			setIsDisabledTipo(false);
		}
	},[tipo, deshabilitarAnotacionesPorTipo]);

	//Habilitar el check solo si "sistema_agua" = red ---> 1
	const [isDisabledAgua, setIsDisabledAgua] = useState(true);

	useEffect(() => {
		if (sistema_agua === "RED"){
			setIsDisabledAgua(false);
		} else {
			setIsDisabledAgua(true);
			setInputsTram({ ...inputsTram, agua_potable_t: eval(false) });
		}
	}, [sistema_agua]);

	//Habilitar el check solo si "eliminacion de excretas" = red_cloacal ---> 1
	const [isDisabledCloaca, setIsDisabledCloaca] = useState(true); // ESTA DISABLED

	useEffect(() => {
		if (eliminacion_excretas === "RED"){
			setIsDisabledCloaca(false); //Habilitado
		} else {
			setIsDisabledCloaca(true); //Deshabilitado
			setInputsTram({ ...inputsTram, eliminacion_excretas_t: eval(false) }); // SI está deshabilitado, deberia estar limpio tambien
		}
	}, [eliminacion_excretas]);

	//Cuando cambia Titular de la tierra, afecta a dos checks
	//---> NO HABILITAR si es ----> municipio, provincia (ibva u otros), estado nacional, banco hipotecario, otros, sin dato
	//** habilitar solo cuando sea 4, 5, 6, 7, 8, 9 o 10
	const [isDisabledActa, setIsDisabledActa] = useState(true); // está DISABLED

	useEffect(() => {
		if(titular_tierra=== "" || titular_tierra === "MUNICIPIO" || titular_tierra === "PROVINCIA (IVBA u otros)" || titular_tierra === "ESTADO NACIONAL" || titular_tierra==="PRIVADOS PARTICULARES"||titular_tierra==="CONDOMINIO"||titular_tierra === "BANCO HIPOTECARIO" || titular_tierra === "OTROS" || titular_tierra === "SIN DATO"){
			setIsDisabledActa(true)
			setInputsTram({
				...inputsTram,
				acta_constitutiva_t: eval(false),
				certif_vigencia_persona_juridica_t: eval(false)
			 })
		} else {
			setIsDisabledActa(false)
		}

	}, [titular_tierra]);

	//**estado para Convenio Urbanistico ---> HABILITAR solo cuando Tipo === 2, 3
	const [isDisabledConvenioU, setIsDisabledConvenioU] = useState(true); //está DISABLED por deault (0) y 1

	useEffect(() => {
		if( tipo === "PROCESOS DE ORGANIZACION COLECTIVA" || tipo === "CONVENIO URBANÍSTICO"){ // 2, 3
			setIsDisabledConvenioU(false); //Disabled false ---> Activo
			//setInputsTram({ ...inputsTram, tipo: e.target.checked });
		} else if(tipo === "INMUEBLES DEL ESTADO") { //1
			setIsDisabledConvenioU(true)
			setInputsTram({
				...inputsTram,
				convenio_urbanistico_t: eval(false),
				anotaciones_personales_t: eval(false)
			});
		} else if (tipo === ""){ //0
			setIsDisabledConvenioU(true);
			setInputsTram({
				...inputsTram,
				convenio_urbanistico_t: eval(false),
				anotaciones_personales_t: eval(false)
			});
		}
	}, [tipo]);

	//**estado Visado de Plano
	//EX 21-09-2026 (paso 7): el setter de este estado no se llamaba nunca, asi que el valor es
	//siempre false. Se deja como constante en vez de un useState para que se vea que es fijo.
	const isDisabledVisadoPlano = false;

	

	//EX 20-09-2026 (fase 2 - paso 4b): el onChange unico es el de la EDICION, que ya era el superconjunto del
	//del alta: mismo bloque textarea/text/select-one, la firma (e, date) y los 5 estados val* de los cuadros
	//de observaciones (abajo, activos). El guard del auto-alto del paso 4a quedo igual: ver el comentario de
	//adentro.
	const onChange = (e, date) => {
		//setOriginal(1);
		cambioOriginal(1);
		const { type } = e.target;

		if(type === 'textarea' || type === 'text' || type === 'select-one' ){
			setInputsTram({ ...inputsTram, [e.target.name]: e.target.value });




			//t_140_observaciones_tramitacion

			//EX 19-09-2026 (fase 2 - paso 4a): el auto-alto es SOLO para los textarea y los input de texto.
			//Estaba dentro del bloque que tambien atiende a los selects ('select-one'), y un <select> de un
			//solo valor tiene e.target.type === 'select-one': al elegir una opcion le escribia un height
			//INLINE igual a su scrollHeight, pisando el height que pone SelectInput, y no se recuperaba
			//nunca (React no vuelve a escribir el estilo si el objeto es igual al anterior). Es el mismo
			//bug que se arreglo en el Tab 1 (commit 7db2483).
			if(type === 'textarea' || type === 'text'){
				e.target.style.height = 'auto';
				e.target.style.height = `${e.target.scrollHeight}px`;
			}

		} else if(type === 'number'){

		} else if (e.target.type === 'checkbox') {
			setInputsTram({ ...inputsTram, [e.target.name]: e.target.checked });
		}
	}

	//CAMBIO 5-4-22
	

	const handleFecha1 = (item) => {
		//setOriginal(1);
		cambioOriginal(1);
		const fecha = item.value;
		setInputsTram({ ...inputsTram, [item.name]: fecha });
	}
	
	
	
	
	


	return (
		<div>
		<div className="container_row">{/* A --Dentro dos columnas****************************************/}
		<div className="container_div_column">{/*columna 1*/}
			<Row>
				<Col>
					<h6 className="mt-4 text-left subtitulos">ETAPA 1</h6>

					{/*EX 20-09-2026 (fase 2 - paso 4b): los 25 checkboxes del formulario pasan `checked` por
					    valorInicial: con precargarDatos = true (edicion) muestran el valor guardado y con false
					    (alta) se pasa undefined, o sea exactamente lo mismo que no pasar nada, que es como
					    estaba el alta. Antes la edicion pasaba checked y el alta no pasaba nada.*/}

					<Form.Check type="checkbox">
						<Form.Check.Input name="solicitud_adhesion_t" checked={valorInicial(solicitud_adhesion_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Nota de solicitud de adhesión al programa`}</Form.Check.Label>
					</Form.Check>

					<Form.Check type="checkbox">
						<Form.Check.Input name="certif_urbanistico_municipal_t" checked={valorInicial(certif_urbanistico_municipal_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Memoria descriptiva del proyecto y entorno urbano`}</Form.Check.Label>
					</Form.Check>

					<Form.Check type="checkbox">
						<Form.Check.Input name="certif_no_inundabilidad_t" checked={valorInicial(certif_no_inundabilidad_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Certificado de no inundabilidad del predio`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="anteproyecto_urbano_t" checked={valorInicial(anteproyecto_urbano_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Anteproyecto urbano`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="titulo_propiedad_t" checked={valorInicial(titulo_propiedad_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Título de propiedad y/o datos de inscripción dominial`}</Form.Check.Label>
					</Form.Check>
				</Col>
				<Col>
					<h6 className="mt-4 text-left subtitulos">ETAPA 2</h6>

					<Form.Check type="checkbox">
						<Form.Check.Input name="memoria_descriptiva_obras_t" checked={valorInicial(memoria_descriptiva_obras_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Memoria descriptiva de las obras a ejecutar `}</Form.Check.Label>
					</Form.Check>

					<Form.Check type="checkbox">
						<Form.Check.Input name="energia_electrica_t" checked={valorInicial(energia_electrica_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Prefactibilidad de energía eléctrica`}</Form.Check.Label>
					</Form.Check>

					<Form.Check type="checkbox">
						<Form.Check.Input name="agua_potable_t" checked={valorInicial(agua_potable_t)} type="checkbox" onChange={e => onChange(e)} disabled={isDisabledAgua}/>
						<Form.Check.Label>{`Prefactibilidad de agua potable por red`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="eliminacion_excretas_t" checked={valorInicial(eliminacion_excretas_t)} type="checkbox" onChange={e => onChange(e)} disabled={isDisabledCloaca}/>
						<Form.Check.Label>{`Prefactibilidad de red cloacal`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="apertura_calles_t" checked={valorInicial(apertura_calles_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Factibilidad apertura de calles`}</Form.Check.Label>
					</Form.Check>

					<Form.Check type="checkbox">
						<Form.Check.Input name="acta_constitutiva_t" checked={valorInicial(acta_constitutiva_t)} type="checkbox" onChange={e => onChange(e)} disabled={isDisabledActa}/>
						<Form.Check.Label>{`Acta constitutiva persona jurídica`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="certif_vigencia_persona_juridica_t" checked={valorInicial(certif_vigencia_persona_juridica_t)} type="checkbox" onChange={e => onChange(e)} disabled={isDisabledActa}/>
						<Form.Check.Label>{`Certificado de vigencia de persona jurídica`}</Form.Check.Label>
					</Form.Check>

					<Form.Check type="checkbox">
						<Form.Check.Input name="plano_mensura_t" checked={valorInicial(plano_mensura_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Plano de mensura y división`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="convenio_urbanistico_t" checked={valorInicial(convenio_urbanistico_t)} type="checkbox" onChange={e => onChange(e)} disabled={isDisabledConvenioU} />
						<Form.Check.Label>{`Convenio urbanístico`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="ordenanza_municipal_t" checked={valorInicial(ordenanza_municipal_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Ordenanza municipal`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="memoria_descriptiva_procedimientos_t" checked={valorInicial(memoria_descriptiva_procedimientos_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Memoria descriptiva del procedimiento de adjudicación`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="t_144_proyecto_hidraulico" checked={valorInicial(t_144_proyecto_hidraulico)} type="checkbox" onChange={e => onChange(e)} disabled={isDisabledProy_Hidraul}/>
						<Form.Check.Label>{`Proyecto Hidráulico`}</Form.Check.Label>
					</Form.Check>
				</Col>

			</Row>
		</div>{/*cierra container_div_column*/}


		<div className="container_div_column">{/* mb-3 */}
			<Row>
				<Col>
					<h6 className="mt-4 text-left subtitulos">TRAMITACIONES DE LA DPPH</h6>

					<Form.Check type="checkbox">
						<Form.Check.Input name="informe_dominio_t" checked={valorInicial(informe_dominio_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Informe de dominio`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="anotaciones_personales_t" checked={valorInicial(anotaciones_personales_t)} type="checkbox" onChange={e => onChange(e)} disabled={isDisabledTipo}/>
						<Form.Check.Label>{`Anotaciones personales`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="admisibilidad_inicial_t" checked={valorInicial(admisibilidad_inicial_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Admisibilidad inicial`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="prefactibilidad_urbanistica_t" checked={valorInicial(prefactibilidad_urbanistica_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Prefactibilidad urbanística `}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="prefactibilidad_hidraulica_t" checked={valorInicial(prefactibilidad_hidraulica_t)} type="checkbox" onChange={e => onChange(e)} disabled={isDisabledPrefacHidraulica}/>
						<Form.Check.Label>{`Prefactibilidad hidráulica y permisos - ADA`}</Form.Check.Label>
					</Form.Check>
				</Col>


				<Col>
					<h6 className="mt-5 text-left"></h6>
					<Form.Check type="checkbox">
						<Form.Check.Input name="certif_tecnico_urbanistico_t" checked={valorInicial(certif_tecnico_urbanistico_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Certificado técnico urbanístico`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="resolucion_afectacion_t" checked={valorInicial(resolucion_afectacion_t)} type="checkbox" onChange={e => onChange(e)}/>
						<Form.Check.Label>{`Resolución de afectación`}</Form.Check.Label>
					</Form.Check>
					<Form.Check type="checkbox">
						<Form.Check.Input name="visado_plano_t" checked={valorInicial(visado_plano_t)} type="checkbox" onChange={e => onChange(e)} disabled={isDisabledVisadoPlano}/>
						<Form.Check.Label>{`Visado de plano`}</Form.Check.Label>
					</Form.Check>
				</Col>
			</Row>
		</div>{/* cierra column*/}
		</div>{/*cierra container_row A*/}

			<div className="container_row">{/* B --Dentro dos columnas***********************************************/}

				<div className="container_div_column">{/*mb-3*/}
					<div className="input-container">
						<textarea
							title="Observaciones para reporte al municipio"
							type="text"
							id="pr2"
							maxLength="3000"
							//EX 20-09-2026 (fase 2 - paso 4b): este cuadro de observaciones (igual que el de
							//internas y el de visado/t_140) ya pasaba `value` en los DOS flujos, asi que queda
							//con `value` directo, sin valorInicial: el alta tiene que quedar igual que estaba
							//(controlada). valorInicial va solo en t_131 y t_136, que eran la diferencia real.
							value={observaciones_reporte_t}
							name="observaciones_reporte_t"
							onChange={e => onChange(e)}
							rows={5}
						/>
						<label alt="Observaciones para reporte al municipio" for="pr2">Observaciones para reporte al municipio</label>
						<p align="right" style={{ fontSize: "0.9em"}}>Caracteres restantes: {maxObservR}</p>
					</div>
				</div>{/* cierra container_div_column*/}

				<div className="container_div_column">{/*mb-3*/}
					<div className="input-container">
						<textarea
							title="Observaciones internas"
							type="text"
							id="id_observaciones_internas_t"
							maxLength="3000"
							value={observaciones_internas_t}
							name="observaciones_internas_t"
							onChange={e => onChange(e)}
							rows={5}
						/>
						<label alt="Observaciones internas" for="id_observaciones_internas_t">Observaciones internas</label>
						<p align="right" style={{ fontSize: "0.9em"}}>Caracteres restantes: {maxObservaciones}</p>
					</div>
				</div>{/* cierra column*/}

			</div>{/*cierra container_left B*/}


		<div className="container_row">{/* C -- Dentro dos columnas**********************************************************/}
			<div className="container_div_column">{/*mb-3*/}
				<h6 className="mt-4 text-left subtitulos">PREFACTIBILIDAD HIDRÁULICA</h6>

				<div className="container_left">
					<div className="input-container">
						<SelectInput
							name="t_127_tramitacion_ada_prefac_h"
							id="id_t_127_tramitacion_ada_prefac_h"
							//EX 20-09-2026 (fase 2 - paso 4b): este es el primero de los 7 controles donde la
							//edicion precargaba (defaultValue/value) y el alta no pasaba nada. Los otros 6:
							//expediente_prefac_h_t, t_131_observaciones_prefact_h, t_145_cpu_tramitacion,
							//t_137_tramitacion_visado, t_132_tramitacion_resol y t_136_observaciones_resol.
							defaultValue={valorInicial(t_127_tramitacion_ada_prefac_h)}
							onChange={e => onChange(e)}
							options={optionsTramitacionADA}
						/>
						<label alt="Tramitación ADA" for="id_t_127_tramitacion_ada_prefac_h">Tramitación ADA</label>
					</div>{/*cierra ---> input-container */}
				</div>{/*cierra ---> container_left */}

				<div className="container_left">
					<div className="input-container">
						<DatePicker
							title="Fecha de envío"
							name="fecha_envio_prefac_h_t"
							id="id_fecha_envio_prefac_h_t"
							dateFormat="dd/MM/yyyy"
							className="form-control"
							selected={fecha_envio_prefac_h_t}
							onChange={ (date) => handleFecha1({ name: "fecha_envio_prefac_h_t", value: date })}
						/>
						<label className="label-fecha" alt="Fecha de envío" for="id_fecha_envio_prefac_h_t">Fecha de envío</label>
					</div>{/*cierra ---> input-container */}
				</div>{/*cierra ---> container_left */}

				<div className="container_left">
					<div className="input-container">
						<input
							title="Expediente ADA"
							type="text"
							id="id_expediente_prefac_h_t"
							maxLength="35"
							value={valorInicial(expediente_prefac_h_t)}
							name="expediente_prefac_h_t"
							onChange={e => onChange(e)}
						/>
						<label alt="Expediente ADA" for="id_expediente_prefac_h_t">Expediente ADA</label> {/* 128 */}
					</div>{/*cierra ---> input-container */}
				</div>{/*cierra ---> container_left */}

				<div className="container_left">
					<div className="input-container">
						<DatePicker
							title="Fecha de emisión"
							name="fecha_emision_prefac_h_t"
							id="id_fecha_emision_prefac_h_t"
							dateFormat="dd/MM/yyyy"
							className="form-control"
							selected={fecha_emision_prefac_h_t}
							onChange={ (date) => handleFecha1({ name: "fecha_emision_prefac_h_t", value: date })}
						/>
						<label alt="Fecha de emisión" for="id_fecha_emision_prefac_h_t">Fecha de emisión</label>
					</div>{/*cierra ---> input-container */}
				</div>{/*cierra ---> container_left */}

				<div className="container_left" style={{ height: "auto"}}>
					<div className="input-container">
						<textarea
							title="Observaciones tramitación ADA"
							type="text"
							id="id_observaciones_prefact_h"
							maxLength="500"
							name="t_131_observaciones_prefact_h"
							value={valorInicial(t_131_observaciones_prefact_h)}
							onChange={e => onChange(e)}
							rows={5}
						/>
						<label alt="Observaciones tramitación ADA" for="id_observaciones_prefact_h">Observaciones tramitación ADA </label>
						<p align="right" style={{ fontSize: "0.9em"}}>Caracteres restantes: {maxObservTramADA}</p>
					</div>{/*cierra ---> input-container */}
				</div>{/*cierra ---> container_left */}
			</div>{/* cierra container_div_column*/}

			<div className="container_div_column">{/*ABRE Nueva columna **************************************************/}
				<h6 className="mt-4 text-left subtitulos">CERTIFICADO DE PREFACTIBILIDAD URBANÍSTICA</h6>

					<div className="container_left">
						<div className="input-container">
							<SelectInput
								name="t_145_cpu_tramitacion"
								defaultValue={valorInicial(t_145_cpu_tramitacion)}
								id="id_t_145_cpu_tramitacion"
								onChange={e => onChange(e)}
								options={optionsTramitacionCPU}
							/>
							<label alt="Tramitación ADA" for="id_t_145_cpu_tramitacion">Tramitación CPU</label>
						</div>
					</div>

					<div className="container_left">
						<div className="input-container">
							<DatePicker
								title="Fecha de envío"
								name="t_146_cpu_fecha_envio"
								id="id_t_146_cpu_fecha_envio"
								dateFormat="dd/MM/yyyy"
								className="form-control"
								selected={t_146_cpu_fecha_envio}
								onChange={(date) => handleFecha1({ name: "t_146_cpu_fecha_envio", value: date })}
							/>
							<label className="label-fecha" alt="Fecha de envío" for="id_t_146_cpu_fecha_envio">Fecha de envío</label>
						</div>
					</div>

					<div className="container_left">
						<div className="input-container">
							<DatePicker
								title="Fecha de emisión"
								name="t_147_cpu_fecha_emision"
								id="id_t_147_cpu_fecha_emision"
								dateFormat="dd/MM/yyyy"
								className="form-control"
								selected={t_147_cpu_fecha_emision}
								onChange={(date) => handleFecha1({ name: "t_147_cpu_fecha_emision", value: date })}
							/>
							<label alt="Fecha de emisión" for="id_t_147_cpu_fecha_emision">Fecha de emisión</label>
						</div>
					</div>

					<div className="container_left">
						<div className="input-container">
							<input
								title="Nro. GDEBA"
								name="t_148_cpu_nro_gdeba"								
								id="id_t_148_cpu_nro_gdeba"
								type="text"
								maxLength="35"
								value={t_148_cpu_nro_gdeba}								
								onChange={e => onChange(e)}
							/>
							<label alt="Nro. GDEBA" for="id_t_148_cpu_nro_gdeba">Nro. GDEBA</label> {/* 128 */}
						</div>
					</div>					

					<div className="container_left" style={{ height: "auto" }}>
						<div className="input-container">
							<textarea
								title="Observaciones tramitación CPU"
								name="t_149_cpu_observaciones"
								id="id_t_149_cpu_observaciones"
								type="text"
								maxLength="500"								
								value={t_149_cpu_observaciones}
								onChange={e => onChange(e)}
								rows={5}
							/>
							<label alt="Observaciones tramitación CPU" for="id_t_149_cpu_observaciones">Observaciones tramitación CPU </label>
							<p align="right" style={{ fontSize: "0.9em" }}>Caracteres restantes: {maxObservTramADA}</p>
						</div>
					</div>				

			</div>{/* cierra container_div_column*/}
		</div>{/*cierra container_left (tiene 2 columnas dentro) - C */}

		<div className="container_row">{/* D -- Dentro dos columnas********************************************************/}
			<div className="container_div_column">{/*mb-3*/}
				<h6 className="mt-4 text-left subtitulos">VISADO DE PLANO - HÁBITAT</h6>

				<div className="container_left" >
					<div className="input-container">
						<SelectInput
							name="t_137_tramitacion_visado"
							id="id_t_137_tramitacion_visado"
							defaultValue={valorInicial(t_137_tramitacion_visado)}
							onChange={e => onChange(e)}
							options={optionsTramitacionVisado}
						/>
						<label alt="Tramitación Visado" for="id_t_137_tramitacion_visado">Tramitación visado</label>
					</div>
				</div>{/*cierra ---> container_left */}

				<div className="container_left">
					<div className="input-container">
						<DatePicker
							placeholder="Fecha de visado" title="Fecha de visado"
							name="fecha_visado_plano_t"
							id="id_fecha_visado_plano_t"
							dateFormat="dd/MM/yyyy"
							className="form-control"
							selected={fecha_visado_plano_t}
							//onChange={handleFecha3}
							onChange={ (date) => handleFecha1({ name: "fecha_visado_plano_t", value: date })}
							//placeholderText="Fecha de visado"
						/>
						<label alt="Fecha de visado" for="id_fecha_visado_plano_t">Fecha de visado</label>
					</div>
				</div>{/*cierra ---> container_left */}

				<div className="container_left">
					<div className="input-container">
						<DatePicker
							placeholder="Fecha de entrega" title="Fecha de entrega"
							name="t_139_fecha_entrega"
							id="id_t_139_fecha_entrega"
							dateFormat="dd/MM/yyyy"
							className="form-control"
							selected={t_139_fecha_entrega}
							onChange={ (date) => handleFecha1({ name: "t_139_fecha_entrega", value: date })}
						/>
						<label alt="Fecha de entrega" for="id_t_139_fecha_entrega">Fecha de entrega</label>
					</div>
				</div>{/*cierra ---> container_left */}

				<div className="container_left" style={{ height: "auto"}}>
					<div className="input-container">
						<textarea
							title="Observaciones tramitación visado"
							type="text"
							id="id_t_140_observaciones_tramitacion"
							maxLength="2000"
							value={t_140_observaciones_tramitacion}
							name="t_140_observaciones_tramitacion"
							onChange={e => onChange(e)}
							rows={5}
						/>
						<label alt="Observaciones tramitación visado" for="id_t_140_observaciones_tramitacion">Observaciones tramitación visado</label>
						<p align="right" style={{ fontSize: "0.9em"}}>Caracteres restantes: {maxObservaciones_140}</p>
					</div>
				</div>{/* cierra ---> container_left */}

			</div>{/* cierra container_div_column*/}

			<div className="container_div_column">{/*ABRE Nueva columna **************************************************/}
				<h6 className="mt-4 text-left subtitulos">RESOLUCIÓN</h6>

				<div className="container_left">
					<div className="input-container">
						<SelectInput
							name="t_132_tramitacion_resol"
							id="id_t_132_tramitacion_resol"
							defaultValue={valorInicial(t_132_tramitacion_resol)}
							onChange={e => onChange(e)}
							options={optionsTramitacionResolucion}
						/>
						<label alt="Tramitación Resolución" for="id_t_132_tramitacion_resol">Tramitación resolución</label>
					</div>{/*cierra ---> input-container */}
				</div>{/*cierra ---> container_left */}

				<div className="container_left">
					<div className="input-container">
						<DatePicker
							//id="startDate"
							title="Fecha de envío"
							id="id_fecha_envio_resol_t"
							name="fecha_envio_resol_t"
							dateFormat="dd/MM/yyyy"
							className="form-control"
							selected={fecha_envio_resol_t}
							onChange={ (date) => handleFecha1({ name: "fecha_envio_resol_t", value: date })}
						/>
						<label alt="Fecha envío resolución" for="id_fecha_envio_resol_t">Fecha de envío</label>
					</div>{/*cierra ---> input-container */}
				</div>{/*cierra ---> container_left */}

				<div className="container_left">
					<div className="input-container">
						<DatePicker
							type="dataPicker"
							title="Fecha de emisión"
							name="fecha_emision_resol_t"
							id="id_fecha_emision_resol_t"
							dateFormat="dd/MM/yyyy"
							className="form-control"
							selected={fecha_emision_resol_t}
							onChange={ (date) => handleFecha1({ name: "fecha_emision_resol_t", value: date })}
						/>
						<label alt="Fecha de emisión" for="id_fecha_emision_resol_t">Fecha de emisión</label>
					</div>{/*cierra ---> input-container */}
				</div>{/*cierra ---> container_left */}

				<div className="container_left">
					<div className="input-container">
						<input
							title="Número especial"
							type="text"
							maxLength="35"
							value={numero_especial_resol_t}
							name="numero_especial_resol_t"
							id="id_numero_especial_resol_t"
							onChange={e => onChange(e)}
						/>
						<label alt="Número especial" for="id_numero_especial_resol_t">Número especial</label>
					</div>{/*cierra ---> input-container */}
				</div>{/*cierra ---> container_left */}

				<div className="container_left" style={{ height: "auto"}}>
					<div className="input-container">
						<textarea
							title="Observaciones tramitación resolución"
							type="text"
							maxLength="500"
							name="t_136_observaciones_resol"
							id="id_t_136_observaciones_resol"
							value={valorInicial(t_136_observaciones_resol)}
							onChange={e => onChange(e)}
							rows={5}
						/>
						<label alt="Observaciones tramitación resolución" for="id_t_136_observaciones_resol">Observaciones tramitación resolución</label>
						<p align="right" style={{ fontSize: "0.9em"}}>Caracteres restantes: {maxObservResol}</p>
					</div>{/*cierra ---> input-container */}
				</div>{/*cierra ---> container_left */}

			</div>{/* cierra container_div_column*/}
		</div>{/*cierra container_left - D */}

		</div>
	)
};

export default TramiteExp;
